var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Delete as IconDelete, FileCopyOutlined as FileCopyOutlinedIcon, Search as SearchIcon, VisibilityOffOutlined as IconVisibilityOff, VisibilityOutlined as IconVisibility, } from "@mui/icons-material";
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput, Tooltip, } from "@mui/material";
import * as clipboard from "clipboard-polyfill";
import clsx from "clsx";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useStyles } from "./ui_text_field.css";
export const UiTextField = (_a) => {
    var { copied, copiedTooltip, className, disabled, error, errorMessage, fullWidth, gutterBottom, label, onDelete, search, type } = _a, props = __rest(_a, ["copied", "copiedTooltip", "className", "disabled", "error", "errorMessage", "fullWidth", "gutterBottom", "label", "onDelete", "search", "type"]);
    const labelRef = useRef(null);
    const [isContentVisible, setIsContentVisible] = useState(false);
    const [isCopyTooltipOpen, setCopyTooltipOpen] = useState(false);
    const [tooltipTimer, setTooltipTimer] = useState(null);
    const [isCopying, setIsCopying] = useState(false);
    const classes = useStyles({ gutterBottom });
    const handleCopyClick = useCallback(() => {
        const value = props.value ? String(props.value) : "";
        setIsCopying(true);
        clipboard.writeText(value).then(() => {
            setCopyTooltipOpen(true);
            const closeTimer = setTimeout(() => {
                setCopyTooltipOpen(false);
                setIsCopying(false);
            }, 1500);
            setTooltipTimer(closeTimer);
        });
    }, [props.value]);
    const handleMouseClick = useCallback(() => {
        setIsContentVisible(!isContentVisible);
    }, [isContentVisible, setIsContentVisible]);
    useEffect(() => {
        if (tooltipTimer) {
            return () => clearTimeout(tooltipTimer);
        }
    }, [tooltipTimer]);
    return useMemo(() => (_jsxs("div", { className: classes.ui_text_field, children: [_jsxs(FormControl, { className: className, error: error, fullWidth: fullWidth, variant: "outlined", children: [_jsx(InputLabel, { disabled: disabled, ref: labelRef, children: label }), _jsx(OutlinedInput, Object.assign({ autoComplete: "nope", disabled: disabled, endAdornment: copied || !!onDelete || type === "password" || search ? (_jsxs(InputAdornment, { position: "end", children: [copied && !!copiedTooltip && (_jsx(Tooltip, { disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, open: isCopyTooltipOpen, PopperProps: {
                                        disablePortal: true,
                                    }, title: copiedTooltip, children: _jsx(IconButton, { color: "primary", disabled: isCopying, onClick: handleCopyClick, size: "small", children: _jsx(FileCopyOutlinedIcon, {}) }) })), search && (_jsx(SearchIcon, { className: classes.icon_button, fontSize: "small" })), type === "password" && (_jsx(IconButton, { className: clsx(classes.icon_button, {
                                        [classes.icon_button__active]: isContentVisible,
                                    }), onClick: handleMouseClick, size: "small", children: isContentVisible ? (_jsx(IconVisibility, {})) : (_jsx(IconVisibilityOff, {})) })), !!onDelete && (_jsx(IconButton, { className: clsx(classes.icon_button, {
                                        [classes.icon_button__active]: isContentVisible,
                                    }), onClick: onDelete, size: "small", children: _jsx(IconDelete, {}) }))] })) : null, type: type === "password"
                            ? isContentVisible
                                ? "text"
                                : "password"
                            : type, label: label }, props))] }), error && errorMessage && (_jsx(FormHelperText, { children: errorMessage }))] })), [
        className,
        classes.icon_button,
        classes.icon_button__active,
        classes.ui_text_field,
        copied,
        copiedTooltip,
        disabled,
        error,
        errorMessage,
        fullWidth,
        handleCopyClick,
        handleMouseClick,
        isContentVisible,
        isCopyTooltipOpen,
        isCopying,
        label,
        onDelete,
        props,
        search,
        type,
    ]);
};
//# sourceMappingURL=ui_text_field.js.map